import { render } from "./SinglePares8.vue?vue&type=template&id=2867e704"
import script from "./SinglePares8.vue?vue&type=script&lang=js"
export * from "./SinglePares8.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Plopfox\\Documents\\Julian\\Dev\\Repositorios\\folleselavida-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__